import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { ProcessingJobData } from "@/app/types/job/ProcessingJob";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useInvalidateOnJobCompletion(jobs: ProcessingJobData[] | undefined): void {
  const queryClient = useQueryClient();
  const runningJobIds = useRef<number[]>([]);

  useEffect(() => {
    if (!jobs) {
      return;
    }

    const running = new Set(jobs.map((job) => job.id));

    const hasFinished = runningJobIds.current.some((id) => !running.has(id));

    if (hasFinished) {
      queryClient.invalidateQueries({ queryKey: [QueryKey.AUTH_USER] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROJECT_INSIGHTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROJECT_PATTERNS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.CALL_ANALYSIS_OVERVIEW] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.CATEGORY_INSIGHTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.INSIGHT_CALLS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROJECT_RECOMMENDATIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.CALLS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.CLIENT_AVATAR] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROJECT_OFFER] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.ANALYSED_CALLS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.HAS_ANALYSED_CALL] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.HAS_PROJECT_INSIGHTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROSPECT_CRITERIA] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.PROSPECT_SEARCH_SUMMARY] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.IMPORTED_BASE] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.MESSAGE_SEQUENCE] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.SEQUENCE_OBJECTIVE] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.SCRIPT] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.FAILED_JOBS] });
    }

    runningJobIds.current = [...running];
  }, [jobs, queryClient]);
}
